import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import axios from '../../config/axiosInstance';

const AddEditGroup = ({ visible, onClose, group, onSave }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (group) {
      form.setFieldsValue({
        name: group.name,
      });
    } else {
      form.resetFields();
    }
  }, [group, form]);

  const handleFinish = async (values) => {
    try {
      if (group) {
        // Update group
        await axios.put(`/groups/${group._id}`, values);
        message.success('Group updated successfully');
      } else {
        // New group
        await axios.post('/groups', values);
        message.success('Group added successfully');
      }
      onSave(); 
      onClose(); 
    } catch (error) {
      console.error('Error saving user:', error);
      message.error('Error saving user. Please try again.');
    }
  };

  return (
    <Modal
      open={visible}
      title={group ? 'Edit Group' : 'Add New Group'}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{ groupID: null, clientID: null }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            { required: true, message: 'Please input the name!' },
            { min: 3, message: 'name must be at least 3 characters' },
          ]}
        >
          <Input placeholder="Enter a name" />
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            {group ? 'Save Changes' : 'Add Group'}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEditGroup;